import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function Dashboard({ user }) {
  const [kpi, setKpi] = useState(null);
  const [recentTickets, setRecentTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('armesa_token');
      const headers = { Authorization: `Bearer ${token}` };

      const [kpiRes, ticketsRes] = await Promise.all([
        axios.get(`${API_URL}/api/kpi`, { headers }),
        axios.get(`${API_URL}/api/tickets?limit=5`, { headers })
      ]);

      setKpi(kpiRes.data);
      setRecentTickets(ticketsRes.data.tickets || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="dashboard" data-testid="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Welcome back, {user?.username}!</p>
      </div>

      <div className="kpi-grid">
        <div className="kpi-card" data-testid="kpi-total">
          <div className="kpi-icon blue">
            <i className="fas fa-ticket-alt"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.total_tickets || 0}</div>
            <div className="kpi-label">Total Tickets</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-open">
          <div className="kpi-icon green">
            <i className="fas fa-folder-open"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.open_tickets || 0}</div>
            <div className="kpi-label">Open</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-claimed">
          <div className="kpi-icon purple">
            <i className="fas fa-user-check"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.closed_today || 0}</div>
            <div className="kpi-label">In Progress</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-closed">
          <div className="kpi-icon gray">
            <i className="fas fa-check-circle"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.closed_today || 0}</div>
            <div className="kpi-label">Closed</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-response">
          <div className="kpi-icon orange">
            <i className="fas fa-clock"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.avg_response_time_min || 0}m</div>
            <div className="kpi-label">Ø Response Time</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-resolution">
          <div className="kpi-icon teal">
            <i className="fas fa-hourglass-half"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">0h</div>
            <div className="kpi-label">Ø Resolution Time</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-sla">
          <div className="kpi-icon red">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.sla_breached || 0}</div>
            <div className="kpi-label">SLA Breaches</div>
          </div>
        </div>

        <div className="kpi-card" data-testid="kpi-escalations">
          <div className="kpi-icon yellow">
            <i className="fas fa-level-up-alt"></i>
          </div>
          <div className="kpi-content">
            <div className="kpi-value">{kpi?.escalated || 0}</div>
            <div className="kpi-label">Escalations</div>
          </div>
        </div>
      </div>

      <div className="recent-section">
        <div className="section-header">
          <h2>Recent Tickets</h2>
          <Link to="/tickets" className="btn btn-secondary">View All</Link>
        </div>

        <div className="tickets-table-container">
          <table className="tickets-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Description</th>
                <th>Roblox Username</th>
                <th>priority</th>
                <th>Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {recentTickets.map((ticket) => (
                <tr key={ticket.id}>
                  <td>#{ticket.id ? ticket.id.substring(0, 8) : 'N/A'}</td>
                  <td>
                    <Link to={`/tickets/${ticket.id}`} className="ticket-link">
                      {ticket.subject}
                    </Link>
                  </td>
                  <td>{ticket.type}</td>
                  <td>
                    <span className={`badge badge-${ticket.priority || 'medium'}`}>
                      {(ticket.priority || 'medium').toUpperCase()}
                    </span>
                  </td>
                  <td>
                    <span className={`badge badge-${ticket.status || 'open'}`}>
                      {(ticket.status || 'open').toUpperCase()}
                    </span>
                  </td>
                  <td>{ticket.created_at ? new Date(ticket.created_at).toLocaleString('de-DE') : 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;